export default "__VITE_ASSET__6Yz65V8w__"